import { render, staticRenderFns } from "./DevolucaoTotalQuebra.vue?vue&type=template&id=29360935&scoped=true&"
import script from "./DevolucaoTotalQuebra.vue?vue&type=script&lang=js&"
export * from "./DevolucaoTotalQuebra.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoTotalQuebra.vue?vue&type=style&index=0&id=29360935&scoped=true&lang=css&"
import style1 from "./DevolucaoTotalQuebra.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29360935",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
